import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {ContactStepComponent} from './contact-step/contact-step.component';
import {RequiredCardStepComponent} from './required-card-step/required-card-step.component';
import {RequiredPersonalStepComponent} from './required-personal-step/required-personal-step.component';
import {ProfileContactResolverService} from '../profile/profile-contact/profile-contact.resolver.service';
import {ProfilePersonalResolverService} from '../profile/profile-personal/profile-personal.resolver.service';
import {QuickAddressCaptureComponent} from './quick-address-capture/quick-address-capture.component';

const routes: Routes = [
    {
        path: 'add-data',
        component: RequiredPersonalStepComponent,
        resolve: { response: ProfilePersonalResolverService },
    },
    {
        path: 'add-contact-data',
        component: ContactStepComponent,
        resolve: { response: ProfileContactResolverService },
    },
    {
        path: 'add-card',
        component: RequiredCardStepComponent,
    },
    {
        path: 'confirm-zip-code',
        component: QuickAddressCaptureComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SetupRoutingModule {}
